import React, { lazy } from 'react';
import EditorLoadableWrapper from '../../MuroEditorLoadableWrapper';
import { MuroProps } from '../../types';
import retry from '@wix/da-shared-react/pkg/utils/webpack/chunkRetry';

const LoadableEditor = lazy(() =>
  retry(
    () =>
      import(
        /* webpackChunkName: "muro_editor" */
        './Mobile'
      )
  )
);

const MobileLoadable: React.FC<MuroProps> = props => {
  return (
    <EditorLoadableWrapper>
      <LoadableEditor {...props} isStoryboard={true} />
    </EditorLoadableWrapper>
  );
};

MobileLoadable.displayName = 'MobileLoadable';
export default MobileLoadable;
